export enum StackPath {
  Foundations = "foundations",
  Customer = "customer",
  Brand = "brand",
  Product = "product",
  Membership = "membership",
  Experience = "experience",
  Content = "content",
  Comms = "comms",
  Operations = "operations",
  Growth = "growth",
  Sales = "sales",
  Partnerships = "partnerships",
  Policy = "policy",
  Hr = "hr",
  Sustainability = "sustainability",
  Sponsorships = "sponsorships",
  Podcast = "podcast",
  Grants = "grants",
  Events = "events",
  Designer = "designer",
  Education = "education",
  Startup = "startup",
  PublisherMedia = "publisher-media",
  Farm = "farm",
  Ecomm = "ecomm",
  Efuels = "efuels",
  Travel = "travel",
  Consulting = "consulting",
  Architect = "architect",
  Wine = "wine",
  Beverage = "beverage",
  Accommodation = "accommodation",
  SelfStorage = "self-storage",
  Restaurant = "restaurant",
  RealEstate = "real-estate",
  Dentist = "dentist",
  Doctor = "doctor",
  Charity = "charity",
  Agency = "agency",
  Construction = "construction",
  Fund = "fund",
  Manufacturing = "manufacturing",
  Coach = "coach",
  SportsTeam = "sports-team",
  PersonalTrainer = "personal-trainer",
  Gym = "gym",
  Athlete = "athlete",
  ClimbingGym = "climbing-gym",
  GolfClub = "golf-club",
  LandManagement = "land-management",
  Retail = "retail",
  Research = "research",
  BuildingManagement = "building-management",
  Lawyer = "lawyer",
  Mining = "mining",
  Legacy = "legacy",
}

export const stackPathName = {
  [StackPath.Foundations]: "Foundations",
  [StackPath.Customer]: "Customer",
  [StackPath.Brand]: "Brand",
  [StackPath.Product]: "Product",
  [StackPath.Membership]: "Membership",
  [StackPath.Experience]: "Experience",
  [StackPath.Content]: "Content",
  [StackPath.Comms]: "Advertising",
  [StackPath.Operations]: "Operations",
  [StackPath.Growth]: "Growth",
  [StackPath.Sales]: "Sales",
  [StackPath.Partnerships]: "Partnerships",
  [StackPath.Policy]: "Policy",
  [StackPath.Hr]: "Recruiting",
  [StackPath.Sustainability]: "Sustainability",
  [StackPath.Sponsorships]: "Sponsorships",
  [StackPath.Podcast]: "Podcast",
  [StackPath.Grants]: "Grants",
  [StackPath.Events]: "Events",
  [StackPath.Designer]: "Designer",
  [StackPath.Education]: "Education",
  [StackPath.Startup]: "Investment",
  [StackPath.PublisherMedia]: "Publisher Media",
  [StackPath.Farm]: "Farm",
  [StackPath.Ecomm]: "Ecomm",
  [StackPath.Efuels]: "eFuels",
  [StackPath.Travel]: "Travel",
  [StackPath.Consulting]: "Consulting",
  [StackPath.Architect]: "Architecture",
  [StackPath.Wine]: "Wine",
  [StackPath.Beverage]: "Beverage",
  [StackPath.Accommodation]: "Accommodation",
  [StackPath.SelfStorage]: "Self Storage",
  [StackPath.Restaurant]: "Restaurant",
  [StackPath.RealEstate]: "Real Estate",
  [StackPath.Dentist]: "Dentist",
  [StackPath.Doctor]: "Doctor",
  [StackPath.Charity]: "Non-profit",
  [StackPath.Agency]: "Agency",
  [StackPath.Construction]: "Construction",
  [StackPath.Fund]: "Fund",
  [StackPath.Manufacturing]: "Manufacturing",
  [StackPath.Coach]: "Coach",
  [StackPath.SportsTeam]: "Sports Team",
  [StackPath.PersonalTrainer]: "Personal Trainer",
  [StackPath.Gym]: "Gym",
  [StackPath.Athlete]: "Athlete",
  [StackPath.ClimbingGym]: "Climbing Gym",
  [StackPath.GolfClub]: "Golf Club",
  [StackPath.LandManagement]: "Land Management",
  [StackPath.Retail]: "Retail",
  [StackPath.Research]: "Research",
  [StackPath.BuildingManagement]: "Building Management",
  [StackPath.Lawyer]: "Lawyer",
  [StackPath.Mining]: "Mining",
  [StackPath.Legacy]: "Legacy",
} as const;
